export default [
  {
    path: '/broadcast',
    name: 'broadcast',
    component: () => import('@/views/broadcast/index.vue'),
    meta: {
      title: 'pc_home_industry',
      pageLevel: 2
    }
  },
  {
    path: '/broadcastAndCourse',
    name: 'broadcastAndCourse',
    component: () => import('@/views/broadcast/BroadcastAndCourse.vue')
  },
  {
    path: '/broadcastDetail/:id?',
    name: 'broadcastDetail',
    component: () => import('@/views/broadcast/BroadcastDetail.vue'),
    meta: {
      title: 'app_details',
      customWechatShare: true,
      pageLevel: 3
    }
  }
]
